var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2101 16.32C15.9669 17.2676 14.4531 17.7926 12.8901 17.8182C7.79923 17.8182 4.89014 12 4.89014 12C5.79478 10.3141 7.04951 8.84118 8.57014 7.68001M11.3629 6.35637C11.8635 6.23919 12.376 6.18062 12.8901 6.18183C17.981 6.18183 20.8901 12 20.8901 12C20.4487 12.8259 19.9222 13.6035 19.3192 14.32M14.432 13.5418C14.2322 13.7562 13.9913 13.9281 13.7237 14.0474C13.4561 14.1666 13.1672 14.2307 12.8742 14.2359C12.5812 14.2411 12.2903 14.1872 12.0186 14.0775C11.7469 13.9677 11.5001 13.8044 11.2929 13.5972C11.0858 13.39 10.9224 13.1432 10.8127 12.8716C10.703 12.5999 10.6491 12.3089 10.6542 12.0159C10.6594 11.723 10.7235 11.4341 10.8428 11.1664C10.962 10.8988 11.134 10.6579 11.3483 10.4582",
    stroke: "#7D7D7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89014 4L20.8901 20",
    stroke: "#7D7D7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/EyeOff.0af7bd89b391263bbc41e318432b7cce.svg";
export { ForwardRef as ReactComponent };